export const tableColumnsKeys = {
  name: 'name',
  number: 'number',
  is_invalid: 'is_invalid',
  tag: 'tag',
  source: 'source',
  keyword: 'keyword',
  areaCode: 'area_code',
}
